module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _c('div', {
    staticClass: "box-content"
  }, [_vm._l((_vm.lstExceriseChooses), function(itemEx, index) {
    return (_vm.lstExceriseChooses && _vm.lstExceriseChooses !== null) ? _c('div', {
      staticClass: "box-item"
    }, [_c('div', {
      staticClass: "item-remove",
      on: {
        "click": function($event) {
          return _vm.removeBoxItem(itemEx)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../../assets/images/theory/delete-24px.svg')
      }
    })]), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "info-title"
    }, [_vm._v("[ID: " + _vm._s(itemEx.id) + "] " + _vm._s(itemEx.name))]), _c('div', {
      staticClass: "info-categories desktop"
    }, [_vm._v("Danh mục: " + _vm._s(itemEx.category_exercise.name))]), _c('div', {
      staticClass: "info-grades desktop"
    }, [_vm._v("Khối lớp: " + _vm._s(_vm.getGrades(itemEx.exercise_grades)))]), _c('div', {
      staticClass: "info-level desktop"
    }, [_vm._v("Cấp độ: " + _vm._s(_vm.getLevel(itemEx.level)))])])]) : _vm._e()
  }), (_vm.isFormShow) ? _c('div', {
    staticClass: "box-item-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group inline-row",
    class: [(_vm.countForm > 1 || _vm.isAddItem) && _vm.key_cate === 0 ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Danh mục bài tập *")]), _c('select', {
    staticClass: "form-control",
    on: {
      "change": function($event) {
        return _vm.onChangeCategories($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "selected": _vm.key_cate === 0
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.categories), function(cate) {
    return (_vm.categories !== null) ? _c('option', {
      domProps: {
        "value": cate.id,
        "selected": cate.id === _vm.key_cate
      }
    }, [_vm._v(_vm._s(cate.text) + " ")]) : _vm._e()
  })], 2)])]), _c('div', {
    staticClass: "col-md-3 split-column"
  }, [_c('div', {
    staticClass: "form-group inline-row"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn khối lớp")]), _c('select', {
    staticClass: "form-control",
    on: {
      "change": _vm.onChangeGrades
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "selected": _vm.key_grade === 0
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.grades), function(item) {
    return (_vm.grades !== null) ? _c('option', {
      domProps: {
        "value": item.id,
        "selected": item.id === _vm.key_grade
      }
    }, [_vm._v(_vm._s(item.text) + " ")]) : _vm._e()
  })], 2)])]), _c('div', {
    staticClass: "col-md-3 split-column"
  }, [_c('div', {
    staticClass: "form-group inline-row"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn cấp độ")]), _c('select', {
    staticClass: "form-control",
    on: {
      "change": _vm.onChangeLevel
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    },
    domProps: {
      "selected": _vm.key_level === 0
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.levels), function(item) {
    return (_vm.levels !== null) ? _c('option', {
      domProps: {
        "value": item.id,
        "selected": item.id === _vm.key_level
      }
    }, [_vm._v(_vm._s(item.title) + " ")]) : _vm._e()
  })], 2)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group inline-row custom-select2",
    class: [(_vm.countForm > 1 || _vm.isAddItem) && _vm.key_exercise === 0 ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn bài tập *")]), _c('Select2', {
    key: _vm.key_increment,
    staticClass: "form-control",
    attrs: {
      "options": _vm.exercises,
      "settings": _vm.settingSelect2
    },
    on: {
      "select": function($event) {
        return _vm.onChangeEvent($event)
      }
    }
  })], 1), _c('div', {
    staticClass: "form-group inline-row",
    class: [(_vm.countForm > 1 || _vm.isAddItem) && (_vm.key_cate === 0 || _vm.key_exercise === 0) ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label required"
  }), _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng điền đầy đủ thông tin")])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group inline-row last-child"
  }, [_c('label', {
    staticClass: "control-label"
  }), _c('button', {
    staticClass: "active",
    on: {
      "click": _vm.addBoxItem
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])]) : _vm._e(), (_vm.countForm === 0) ? _c('a', {
    staticClass: "action-form",
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("+ Thêm bài tập")]) : _c('a', {
    staticClass: "action-form"
  }, [_vm._v("+ Thêm bài tập")]), _c('div', {
    staticClass: "box-share"
  }, [_c('div', {
    staticClass: "item-share-header"
  }, [_vm._v("CHIA SẺ BÀI TẬP *")]), _c('div', {
    staticClass: "item-share-content"
  }, [_c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "public_all",
      "id": "public_all",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm.isPublicSystem
    }
  }), _c('label', {
    attrs: {
      "for": "public_all"
    }
  }), _c('span', [_vm._v("Lưu bài tập và cho phép học sinh trong toàn hệ thống tìm kiếm được để mua đáp án")])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "public_pc",
      "id": "public_pc"
    },
    on: {
      "click": function($event) {
        return _vm.onCheckSave($event, 2)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "public_pc"
    }
  }), _c('span', [_vm._v("Lưu bài tập riêng tư (chỉ cho hiển thị trong cộng đồng và lớp học của tôi)")])]), _c('div', {
    staticClass: "clearfix"
  }), (_vm.isPublicPC) ? _c('div', {
    staticClass: "box-left"
  }, [_c('div', {
    staticClass: "row row-share-class"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    key: _vm.increment_class,
    staticClass: "form-control",
    attrs: {
      "id": "class_id"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("Chọn lớp học bạn muốn chia sẻ trong PC")]), _vm._l((_vm.classes), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])])]), _c('div', {
    staticClass: "row row-class"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.lstClassAdded), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-attach"
    }, [_c('label', [_c('div', {
      staticClass: "attach-left"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/images/theory/ic_class.png")
      }
    }), _c('span', [_vm._v(_vm._s(item.name))])]), _c('div', {
      staticClass: "attach-right"
    }, [_c('span', [_vm._v("Hẹn thời gian")]), _c('dateTimePicker', {
      key: item.increment,
      staticClass: "datetimepicker",
      attrs: {
        "inline": false,
        "id": 'datePicker_' + item.id,
        "value": item.start_date,
        "minDate": false,
        "maxDate": false,
        "locale": 'en'
      },
      on: {
        "onChange": function($event) {
          return _vm.changeDate($event, item)
        }
      }
    })], 1), _c('div', {
      staticClass: "clearfix"
    }), _c('span', {
      staticClass: "material-icons remove",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteClass(item)
        }
      }
    }, [_vm._v("delete")]), _c('div', {
      staticClass: "clearfix"
    })])]) : _vm._e()
  }), 0)])]) : _vm._e()])]), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "submit",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.returnList()
      }
    }
  }, [_vm._v("Huỷ yêu cầu")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_header"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Thêm mới giáo án - Bài tập")]), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449cc963","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson_Planning/Exercise/add.vue
// module id = 1546
// module chunks = 0